// src/components/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, allowedRoles, user }) {
  const storedUser = localStorage.getItem("user");
  const current = user || (storedUser ? JSON.parse(storedUser) : null);
  const location = useLocation();
  if (!current) return <Navigate to="/login" replace state={{ from: location?.pathname || "/" }} />;
  if (Array.isArray(allowedRoles) && allowedRoles.length) {
    const target = allowedRoles.map(r => String(r).toLowerCase());
    const single = String(current.role || "").toLowerCase();
    const multi = Array.isArray(current.roles) ? current.roles.map(r => String(r).toLowerCase()) : [];
    const userRoles = [single, ...multi].filter(Boolean);
    const ok = userRoles.some(r => target.includes(r));
    if (!ok) return <Navigate to="/login" replace state={{ from: location?.pathname || "/" }} />;
  }
  return children;
}
